<template>
  <div class="login-container">
    <v-btn color="primary" large depressed @click="redirectToOIDC">
      Connectez-vous via votre compte INSERM
    </v-btn>
  </div>
</template>

<script>
export default {
  methods: {
    async redirectToOIDC() {
      window.location.href = process.env.VUE_APP_URL_SSO;
    },
  },
};
</script>

<style scoped>
.login-container {
  text-align: center;
  margin-top: 50px;
}
</style>
